//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AddressFieldEditor from './AddressFieldEditor.vue'

export default {
  components: {
    AddressFieldEditor
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    placeholder: {
      type: String,
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hideBottomSpace: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: null
    },
    additionalObjectTypes: {
      type: Array,
      default: null
    }
  },
  data: () => {
    return {
      editorOpened: false,
      editorValue: {
        id: null,
        type: null,
        name: null,
        region: null,
        value: null
      }
    }
  },
  computed: {
    addressText: function () {
      let addressValue = this.value && this.value.value || ''
      if (this.value && this.value.region && this.value.region.name) {
        const regionName = this.value.region.name
        if (addressValue) {
          if (!addressValue.includes(regionName)) {
            addressValue = `(${regionName}) ${addressValue}`
          }
        } else {
          addressValue = regionName
        }
      }
      return addressValue
    },
    objectNameText: function () {
      return this.value && this.value.name ? this.value.name : ''
    }
  },
  methods: {
    onClear: function () {
      this.value.id = null
      this.value.name = null
      this.value.value = null
      this.value.type = null
      this.value.region = null

      this.validate()
    },
    onEdit: function () {
      if (this.value) {
        this.editorValue = JSON.parse(JSON.stringify(this.value))
      }
      this.editorOpened = true
    },
    onApplyChanges: function () {
      if (this.value == null) {
        this.value = {}
      }
      this.value.id = this.editorValue.id
      this.value.name = this.editorValue.name
      this.value.value = this.editorValue.value
      this.value.type = this.editorValue.type
      this.value.region = this.editorValue.region

      this.onCancelChanges()
      this.validate()
    },
    onCancelChanges: function () {
      this.editorValue.id = null
      this.editorValue.name = null
      this.editorValue.value = null
      this.editorValue.type = null
      this.editorValue.region = null

      this.editorOpened = false
    },
    validate: function () {
      return this.$refs.field.validate()
    }
  }
}
